<docs>
# timeSpan component

```pug
timeSpan(@change="getSomeStuff")
//- some stuff

timeSpan(@change="getOtherStuff")
//- other stuff

timeSpan(v-model="timeSpan")
```

```javascript
methods() {
    // ...
    getSomeStuff({ start, end }) {},
    getOtherStuff({ start, end }) {}
}
```
</docs>

<template lang="pug">
.q-timespan
    .timespan(v-for="item in times",
        :class="{ active: item.active }",
        @click="setTimespan(item)"
    ) {{item.name}}
    v-date-range(v-show="custom", :start-date="start", :end-date="end", :min-date="minDate", :max-date="maxDate", @update="updateRange")   
</template>

<script>
import TimespanHelper from './timespanHelper'

export default {
  props: {
    filters: {
      type: String,
      default: 'normal'
    },
    noCommitState: Boolean,
    mintspan: {
      type: Number,
      default: 0
    },
    custom: {
      type: Boolean,
      default: true
    }
  },
  data () {
    const helper = new TimespanHelper()
    return {
      helper,
      times: helper.filterTimes(this.filters),
      start: '',
      end: '',
      minDate: new Date( new Date().getTime() - 365 * 24 * 60 * 60 * 1000 ).format('yyyy-MM-dd'),
      maxDate: new Date().format('yyyy-MM-dd')
    }
  },
  watch: {
    filters () {
      this.times = this.helper.filterTimes(this.filters)
      this.setTimespan(this.times[0])
    }
  },
  methods: {
    setTimespan (item) {
      const { start, end } = item.date
      const currentDate = this.$store.state.dateAsParam

      if ((new Date(end) - new Date(start)) > 365 * 24 * 3600 * 1000) {
        return this.$Modal.warn(`您选择时间段超过了一年`)
      }

      this.helper.setActive(item)
      this.start = start
      this.end = end

      !this.noCommitState && this.$store.commit('SET_CURRENT_DATERANGE', {
        start: this.start,
        end: this.end
      })
      if ( _.isEqual(start, currentDate.start) && _.isEqual(end, currentDate.end)) return
      this.$emit('input', { start, end })
      this.$emit('change', { start, end })
      this.$store.commit('SET_DATE_PARAM', { start, end })
    },
    updateRange (date) {
      const start = date.startDate
      const end = date.endDate
      const currentDate = this.$store.state.dateAsParam

      // 选择的时间超出今天
      if (new Date(end) > new Date()) {
        return this.$Modal.warn('所选时间不能超过今天')
      }
      if (new Date(start) > new Date(end)) {
        return this.$Modal.warn(`开始时间: ${start} 不能早于结束时间: ${end}`)
      }

      // 设置最小时间间隔
      if ((new Date(end) - new Date(start)) < this.mintspan * 24 * 3600 * 1000) {
        return this.$Modal.warn(`您选择时间段不得少于${this.mintspan}天`)
      }

      if ((new Date(end) - new Date(start)) > 365 * 24 * 3600 * 1000) {
        return this.$Modal.warn(`您选择时间段超过了一年`)
      }

      this.helper.deactiveAll()
      this.start = start
      this.end = end

      !this.noCommitState && this.$store.commit('SET_CURRENT_DATERANGE', {
        start: this.start,
        end: this.end
      })
      if ( _.isEqual(start, currentDate.start) && _.isEqual(end, currentDate.end)) return

      this.$emit('input', { start, end })
      this.$emit('change', { start, end })
      this.$store.commit('SET_DATE_PARAM', { start, end })
    }
  },
  created () {
    let { start, end } = this.$store.state.dateAsParam
    let date = { start, end }
    let dataEqual = (item) => _.isEqual(date, item.date)

    if (date.start && date.end) {
      let item = _.find(this.times, dataEqual)
      if (item) {
        this.setTimespan(item)
      } else {
        // 如果是`昨天、今天、最近一周...`这样一些选项
        // 则按照默认的第一个进行
        let item = _.find(this.helper.allTimes, dataEqual)
        if (item || !this.custom) {
          this.setTimespan(this.times[0])
        } else {
          this.updateRange({startDate: start, endDate: end})
        }
      }
    } else {
      this.setTimespan(this.times[0])
      this.maxDate = this.times[0].date.end
    }
  },
  // 销毁时清空作为参数传递作用的 dateAsParam
  destroyed () {
    // this.$store.commit('SET_DATE_PARAM', { start: '', end: '' })
  }
}
</script>

<style>
@import './css-variables.css';

.q-timespan {
    margin: 15px 0;
    display: inline-block;
}

.timespan {
    display: inline-block;
    margin-right: 12px;
    padding: 0 5px;
    cursor: pointer;
    vertical-align: sub;
    &.active {
        color: var(--white-color);
        background-color: var(--primary-color);
    }
}
</style>



// WEBPACK FOOTER //
// timespan.vue?c8bd38ee